import { useState } from "react";
import { Button, THEME } from "@myloc/myloc-gui";
import { useTranslate } from "../../../../../../language/i18n";
import SelectField from "../../../../../shared/SelectField/SelectField";
import registerActionService from "../../../../../../services/registerAction/registerActionService";
import styles from "./ChooseActionStep.module.scss";
import { FormDefinition, OrderDefinition } from "../../../../../../services/registerAction/types";

interface ChooseActionStepProps {
  orderDefinitions: OrderDefinition[];
  selectedDefinition: OrderDefinition | null;
  onSelect: (definition: OrderDefinition) => void;
  onNext: (hasForm: boolean, formDef: FormDefinition | null) => void;
  inventoryId: string;
}

const ChooseActionStep = ({
  orderDefinitions,
  selectedDefinition,
  onSelect,
  onNext,
  inventoryId,
}: ChooseActionStepProps) => {
  const translate = useTranslate();
  const [isLoading, setIsLoading] = useState(false);

  const handleNext = async () => {
    if (!selectedDefinition) return;

    setIsLoading(true);

    try {
      const response = await registerActionService.getFormMapping(inventoryId, selectedDefinition.id);
      const formData = response.data as FormDefinition | undefined;

      if (formData?.sequences) {
        onNext(true, formData);
      } else {
        onNext(false, null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const options = orderDefinitions.map(def => ({
    id: def.id,
    value: def.name ?? def.orderType,
  }));

  return (
    <div className={styles.container}>
      <SelectField
        label={translate("CHOOSE_PERFORMED_ACTION")}
        options={options}
        selectedId={selectedDefinition?.id}
        onSelect={(selected: { id: string }) => {
          const definition = orderDefinitions.find(d => d.id === selected.id);

          if (definition) onSelect(definition);
        }}
        required
      />
      <div className={styles.actions}>
        <Button
          theme={THEME.PRIMARY}
          customCssClass=""
          onClick={handleNext}
          disabled={!selectedDefinition}
          isLoading={isLoading}
        >
          {translate("NEXT")}
        </Button>
      </div>
    </div>
  );
};

export default ChooseActionStep;
